import React, { useEffect, useState } from "react";
import { getAllStudents } from "../../../../requests/students";
import CreateNewStudent from "./CreateNewStudent";
import PlaceManually from "./PlaceManually";
import Search from "./Search";
import ActionMenuContainer from "../../ActionMenuContainer";
import NewStudentForm from "./NewStudentForm";
import SuggestedSchools from "./SuggestedSchools";
import Success from "./Success";

function capitalize(string) {
  if (!string) return;
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

export default function NewStudent({ setRender }) {
  const [students, setStudents] = useState([]);
  const [isShowingResults, setIsShowingResults] = useState(false);
  const [createNewStudent, setCreateNewStudent] = useState(false);
  const [placeManually, setPlaceManually] = useState(false);
  const [search, setSearch] = useState(null);
  const [newStudentForm, setNewStudentForm] = useState(false);
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const [suggestedSchools, setSuggestedSchools] = useState(false);
  const [school, setSchool] = useState(null);
  const [studentData, setStudentData] = useState(false);
  const [success, setSuccess] = useState(false);
  const [studentSearchName, setStudentSearchName] = useState();
  const [loading, setLoading] = useState(false);

  // Let's convert the search term into full name of the user to pre-fill
  const searchNameArray = studentSearchName?.trim().split(" ") || [];

  const searchFullNameArray = [
    capitalize(searchNameArray[0]),
    searchNameArray.length > 2
      ? searchNameArray
          .slice(1, -1)
          .map((name) => capitalize(name))
          .join(" ")
      : undefined,
    searchNameArray.length > 1 ? capitalize(searchNameArray.at(-1)) : undefined,
  ];

  // Using Ransacker gem Search Matcher `*_i_cont_all` pattern.
  // Splitting the query terms into an array for the `cont` matcher.
  const getSearch = async () => {
    const searchTerms = search.trim().split(" ");

    if (searchTerms.length === 0) {
      setLoading(false);
      return;
    }

    const res = await getAllStudents({
      params: {
        pagination: false,
        q: { full_name_i_cont_all: searchTerms },
      },
    });

    if (res.data) {
      setStudents(res.data.students);
      setIsShowingResults(true);
      setLoading(false);
      setSearch(null);
    }
  };

  const onSubmit = (data) => {
    setLoading(true);
    setSearch(data.search);
  };

  const handleGoingBack = () => {
    if (createNewStudent || placeManually) {
      setCreateNewStudent(false);
      setPlaceManually(false);
    } else if (newStudentForm) {
      setNewStudentForm(false);
      setCreateNewStudent(true);
    } else if (suggestedSchools) {
      setSuggestedSchools(false);
      setNewStudentForm(true);
    } else {
      setRender(null);
    }
  };

  useEffect(() => {
    if (search) {
      getSearch();
    }
  }, [search]);

  const renderContent = () => {
    if (success) {
      return (
        <Success
          setSuccess={setSuccess}
          setSuggestedSchools={setSuggestedSchools}
          setCreateNewStudent={setCreateNewStudent}
          school={school}
          selectedCourseId={selectedCourseId}
          studentData={studentData}
        />
      );
    }

    if (suggestedSchools) {
      return (
        <SuggestedSchools
          setSuggestedSchools={setSuggestedSchools}
          setSuccess={setSuccess}
          selectedCourseId={selectedCourseId}
          zipCode={studentData.zip_code}
          setSchool={setSchool}
        />
      );
    }

    if (newStudentForm) {
      return (
        <NewStudentForm
          setNewStudentForm={setNewStudentForm}
          setSuggestedSchools={setSuggestedSchools}
          studentData={studentData}
          setStudentData={setStudentData}
          searchFullNameArray={searchFullNameArray}
        />
      );
    }

    if (createNewStudent) {
      return (
        <CreateNewStudent
          setCreateNewStudent={setCreateNewStudent}
          setNewStudentForm={setNewStudentForm}
          selectedCourseId={selectedCourseId}
          setSelectedCourseId={setSelectedCourseId}
        />
      );
    }

    if (placeManually) {
      return <PlaceManually searchFullNameArray={searchFullNameArray} />;
    }

    return (
      <Search
        students={students}
        onSubmit={onSubmit}
        isShowingResults={isShowingResults}
        setCreateNewStudent={setCreateNewStudent}
        setPlaceManually={setPlaceManually}
        setStudentSearchName={setStudentSearchName}
        loading={loading}
      />
    );
  };

  return (
    <>
      {success ? (
        <ActionMenuContainer label="Student Added Successfully">
          {renderContent()}
        </ActionMenuContainer>
      ) : (
        <ActionMenuContainer
          label="Add New student"
          handleGoingBack={() => handleGoingBack()}
        >
          {renderContent()}
        </ActionMenuContainer>
      )}
    </>
  );
}
